export default {
    actors: [],
    offline_projects: ["oigjerljiqb"],
    online_projects:[],
    project: ""
    };